import React from 'react'
import {useSelector} from 'react-redux'

export default function DataTags() {
    const filters = useSelector((state) => state.filters)
    const {department, category, type} = filters

    return (
        <div className="data-tags hidden">
            <input type="hidden" id="department" value={department || ''} />
            <input type="hidden" id="category" value={category || ''} />
            <input type="hidden" id="type" value={type || ''} />
        </div>
    )
}
